import api from "../../api/api";

//?-----------------------------Get Image from the api----------------------------------
export const get_image = async (data) => {
  return await api.get(`getDboardSliders/${data.usertype}/${data.mediatype}`);
};

//*--------------------------------Save Image---------------------------------------------
export const save_image = async (body) => {
  return await api.post("saveDboardSlider", body);
};

//&------------------------------Update image----------------------------------------------
export const update_image = async (body) => {
  return await api.patch("updateDboardSlider", body);
};

//!------------------------------Delete Image---------------------------------------------------
export const delete_image = async (data) => {
  return await api.delete("deleteDboardSlider/" + data);
};
